import React, { useEffect, useState } from "react"
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import bankServices from "../services/bankServices";
import CreateBankAccountModal from "./modals/createBankAccount";
import ConfirmBankAccountModal from "./modals/confirmBankAccountModel";
import { useSnackbar } from "notistack";
import {
    Button,
    Dialog,
    Stack,
    Box,
    Typography,
} from "@mui/material";
import Label from "../components/label";
import { ManualKYCForm } from "./manualKycForm";


export function BankAccount({ entityId, panCardNumber, entityType, status }) {
    const { enqueueSnackbar } = useSnackbar();
    const [availableBankAccounts, setAvailableBankAccounts] = useState([])
    const [createBankAccount, setCreateBankAccount] = useState(false)
    const [currentIndex, setCurrentIndex] = useState()
    const [primaryOpen, setPrimaryOpen] = useState(false)
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [bankAccountId, setBankAccountId] = useState()
    const [editData, setEditData] = useState({})
    const [url, setUrl] = useState(null)
    const [open, setOpen] = useState(false)
    const [hasPendingOrRejectedBankAccount, setHasPendingOrRejectedBankAccount] = useState(false);

    const getBankAccountOfEntity = async () => {
        const res = await bankServices.getBankAccount(entityId)
        if (res && res.success) {
            setAvailableBankAccounts(res?.data)
            setUrl(res?.url)

            const bankList = res.data;
            if (Array.isArray(bankList)) {
                const hasFlag = bankList.find(
                    (acc) => acc.status === 'PENDING' || acc.status === 'REJECTED'
                );
                setHasPendingOrRejectedBankAccount(!!hasFlag);
            }
        }


    }
    const PrimaryBankAccount = async () => {
        const data = {
            bankAccountId,
            entityId,
            entityType
        }
        try {
            const res = await bankServices.updatePrimaryBankAccount(data)
            if (res && res.success) {
                enqueueSnackbar("Primary Bank account Updated successfully", { variant: "success" });
                getBankAccountOfEntity()
            } else {
                enqueueSnackbar(res?.data?.message, { variant: "error" });
            }
        } catch (error) {
            enqueueSnackbar(error?.data?.message || "Something went wrong", { variant: "error" });
        }
    }
    const DeleteBankAccount = async () => {
        const data = {
            bankAccountId,
            entityId,
            entityType
        }
        try {
            const res = await bankServices.removeBankAccount(data)

            if (res && res.success) {
                enqueueSnackbar("Bank account Deleted successfully", { variant: "success" });
                getBankAccountOfEntity()
            } else {
                enqueueSnackbar(res?.data?.message , { variant: "error" });
            }
        } catch (error) {
            enqueueSnackbar(error?.data?.message || "Something went wrong", { variant: "error" });
        }
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleEdit = (account) => {
        console.log(editData)

        setEditData(account, url)
        setOpen(true)
    }

    useEffect(() => {
        getBankAccountOfEntity()
    }, [])
    const TypographyText = ({ label, value, isRow = false }) => {
        return (
            <Stack direction={isRow ? "row" : { md: "column", xs: "row" }} spacing={1} justifyContent={isRow ? "space-between" : { xs: "space-between", md: "start" }}
                sx={{
                    width: "100%",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                }}>
                <Typography variant="label">
                    {label}
                </Typography>
                <Typography
                    variant="body3"
                    sx={{
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                        overflow: "hidden",
                    }}
                >
                    {value}
                </Typography>
            </Stack>
        );
    };
    return <>
        <ConfirmBankAccountModal open={primaryOpen} setOpen={setPrimaryOpen} handleYes={() => PrimaryBankAccount()} accountNumber={availableBankAccounts[currentIndex]?.accountNumber} ifscCode={availableBankAccounts[currentIndex]?.ifsc} bankName={availableBankAccounts[currentIndex]?.bankName} note={"Are you sure you want to change the Primary Account?"} />
        <ConfirmBankAccountModal open={deleteOpen} setOpen={setDeleteOpen} handleYes={() => DeleteBankAccount()} accountNumber={availableBankAccounts[currentIndex]?.accountNumber} ifscCode={availableBankAccounts[currentIndex]?.ifsc} bankName={availableBankAccounts[currentIndex]?.bankName} note={"Are you sure you want to delete the Bank Account?"} />
        <CreateBankAccountModal open={createBankAccount} setOpen={setCreateBankAccount} panCardNumber={panCardNumber} entityType={entityType} getBankAccountOfEntity={getBankAccountOfEntity} entityId={entityId} />
        {(availableBankAccounts[0] !== undefined && availableBankAccounts.length >= 1) ? (
            availableBankAccounts
                .sort((a, b) => (b.isPrimary ? 1 : -1) - (a.isPrimary ? 1 : -1))
                .map((account, index) => {

                    return (
                        <Box
                            key={account?._id || `${account?.bankName}-${index}`}
                            sx={{
                                width: "100%",
                                p: { xs: 1.5, sm: 2 },
                                borderRadius: 2,
                                boxShadow: 1,
                                my: 0.75,
                            }}
                        >
                            <Stack spacing={1.25}>
                                <Stack
                                    direction={"row"}
                                    alignItems={{ xs: "flex-start", md: "center" }}
                                    justifyContent={ { xs: "space-between", md: "flex-start" }}
                                    gap={1}
                                >
                                    <Typography sx={{ wordBreak: "break-word" }}>
                                        #{index + 1}. {account?.bankName}
                                    </Typography>
                                            {/* <Box onClick={(e) => { e.stopPropagation(); e.preventDefault()}} sx={{ bgcolor: '#f4f6f7', padding: '7px', borderRadius: '50%', marginLeft: '10px',hight:"20px",width:"30px" }}>
                            <CustomIcon
                              name="copy"
                              sx={{ bgcolor: "#FFF", backgroundColor: "#333333", cursor: "pointer" }}
                            />
                          </Box> */}
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        columnGap={1}
                                        rowGap={1}
                                        flexWrap="wrap"
                                        sx={{ width: "auto" }}
                                    >
                                        {account.isPrimary ? (
                                            <Typography
                                                sx={{
                                                    color: "white",
                                                    background: "#21ab37",
                                                    padding: "2px 15px !important",
                                                    fontSize: "12px !important",
                                                    border: "1px solid #21ab37",
                                                    borderRadius: "10px",
                                                    fontSize: { xs: 8, sm: 12 },
                                                }}
                                            >
                                                Primary Account
                                            </Typography>
                                        ) : (
                                            <Stack flexDirection={"row"} alignItems={'center'} columnGap={{ xs: 1, sm: 2 }} sx={{ m: "0 !important" }}>
                                                {account?.status == 'APPROVED' && <Button
                                                    variant="contained"
                                                    sx={{ p: "4px 15px !important", fontSize: "12px !important" }}
                                                    onClick={() => {
                                                        setCurrentIndex(index);
                                                        setPrimaryOpen(true);
                                                        setBankAccountId(account._id)
                                                    }}
                                                >Make Primary</Button>
                                                }
                                            </Stack>
                                        )}

                                        {!account.isPrimary && <RemoveCircleOutlineIcon sx={{ color: "red", cursor: "pointer" }} onClick={() => {
                                            setCurrentIndex(index); setDeleteOpen(true); setBankAccountId(account._id)
                                        }} />}

                                        {account?.status === 'REJECTED' && <Button onClick={() => handleEdit(account)}>Edit</Button>}

                                        {account?.status != 'APPROVED' && account?.status && <Label
                                            sx={{ py: 2, px: 2, fontWeight: 600 }}
                                            //  variant="ghost" 
                                            color={account?.status == 'PENDING' ? 'warning' : account?.status == 'REJECTED' ? 'error' : account.status == 'APPROVED' ? 'success' : ''}>
                                            {account?.status}
                                        </Label>}
                                    </Stack>
                                </Stack>

                                <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    gap={{ xs: 1, sm: 2 }}
                                    sx={{ pt: 0.5, width: "100%" }}
                                >
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                        <TypographyText label="Account Number" value={account?.accountNumber} />
                                    </Box>
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                        <TypographyText label="IFSC Code" value={account?.ifsc} />
                                    </Box>
                                </Stack>
                            </Stack>
                        </Box>
                    )
                })
        ) :
            (
                <>
                    <Typography variant="subtitle1">You did not connected any of your bank accounts yet</Typography>
                </>
            )
        }
        {!hasPendingOrRejectedBankAccount && availableBankAccounts?.length < 3 && status === "APPROVED" && (<>
            {/* {(availableBankAccounts.length !=2&&status==="APPROVED") &&  */}
            <Stack flexDirection={{ xs: "column", sm: "row" }} sx={{ marginTop: 2, width: "100%" }} gap={1}>
                <Button
                    onClick={() => setCreateBankAccount(true)}
                    variant="contained"
                    sx={{ width: { xs: "100%", sm: "max-content" }, py: "10px !important" }}
                >
                    Add Bank Account
                </Button>



            </Stack>
            {/* } */}
        </>

        )}

        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg" >
            <Box padding={1} >

                <Stack>
                    <ManualKYCForm entityId={entityId} open={open} setOpen={setOpen} entityType={entityType} getBankAccountOfEntity={getBankAccountOfEntity} editData={editData} url={url} />
                </Stack>

            </Box>
        </Dialog>
    </>
}